import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter } from "reactstrap";
import {
    renderField,
    renderSelectField,
    required,
    renderPass
} from "../../../../utils/formValidations.js";
import { Field, reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";

class AzureDnsProviderFormTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentProvider: {},
        };
        this.submitApi = this.submitApi.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
    }


    componentDidMount() {
        if (this.props.current_provider) {
            this.props.initialize({
                dns_provider_config_name: this.props.current_provider.dns_provider_config_name,
                dns_provider_name: this.props.current_provider.dns_provider_name,
                azure_subscription_id: this.props.current_provider.azure_subscription_id,
                azure_resource_group: this.props.current_provider.azure_resource_group,
                azure_tenant_id: this.props.current_provider.azure_tenant_id,
                azure_client_id: this.props.current_provider.azure_client_id,
                azure_client_secret: this.props.current_provider.azure_client_secret,
                azure_region: this.props.current_provider.azure_region,
                azure_authority: this.props.current_provider.azure_authority,
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
            this.props.initialize({
                dns_provider_config_name: nextProps.current_provider.dns_provider_config_name,
                dns_provider_name: nextProps.current_provider.dns_provider_name,
                azure_subscription_id: nextProps.current_provider.azure_subscription_id,
                azure_resource_group: nextProps.current_provider.azure_resource_group,
                azure_tenant_id: nextProps.current_provider.azure_tenant_id,
                azure_client_id: nextProps.current_provider.azure_client_id,
                azure_client_secret: nextProps.current_provider.azure_client_secret,
                azure_region: nextProps.current_provider.azure_region,
                azure_authority: nextProps.current_provider.azure_authority,
            });
        }
    }


    cancelButton() {
        this.props.cancel_button(userData)
    }

    submitApi(userData) {
        userData.dns_provider_name = "azure"
        this.props.submit_api(userData)
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="dns_provider_config_name" className="requiredasterisk">Name </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="dns_provider_config_name"
                                    id="dns_provider_config_name"
                                    component={renderField}
                                    validate={required}
                                    placeholder="Example Azure Config"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_subscription_id" className="requiredasterisk">Subscription ID</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_subscription_id"
                                    id="azure_subscription_id"
                                    component={renderField}
                                    validate={required}
                                    placeholder="00000000-0000-0000-0000-000000000000"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_resource_group" className="requiredasterisk">Resource Group</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_resource_group"
                                    id="azure_resource_group"
                                    component={renderField}
                                    validate={required}
                                    placeholder="development"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_tenant_id" className="requiredasterisk">Tenant ID</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_tenant_id"
                                    id="azure_tenant_id"
                                    component={renderField}
                                    validate={required}
                                    placeholder="00000000-0000-0000-0000-000000000000"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_client_id" className="requiredasterisk">Client ID</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_client_id"
                                    id="azure_client_id"
                                    component={renderField}
                                    validate={required}
                                    placeholder="00000000-0000-0000-0000-000000000000"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_client_secret" className="requiredasterisk">Client Secret</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="password"
                                    name="azure_client_secret"
                                    id="azure_client_secret"
                                    component={renderPass}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_authority" className="requiredasterisk">Azure Authority</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_authority"
                                    id="azure_authority"
                                    component={renderSelectField}
                                    validate={required}>
                                    <option>Select...</option>
                                    <option value="AZURE_PUBLIC_CLOUD">Azure Public Cloud</option>
                                    <option value="AZURE_GOVERNMENT">Azure Government</option>
                                    <option value="AZURE_CHINA">Azure China</option>
                                    <option value="AZURE_GERMANY">Azure Germany</option>
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_region" className="requiredasterisk">Region</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_region"
                                    id="azure_region"
                                    component={renderField}
                                    validate={required}
                                    placeholder="eastus"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="button" size="sm"
                            className="cancel-button"
                            color="basic" onClick={() => this.props.cancel_button()}>{ this.props.wizard ? 'Previous' : 'Cancel'}</Button>
                        <Button type="submit"
                            className="submit-button"
                            size="sm" color="primary">{ this.props.wizard ? 'Finish' : 'Submit'}</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}


AzureDnsProviderFormTemplate.propTypes = {
    current_provider: Proptypes.object,
    submit_api: Proptypes.func.isRequired,
    handleSubmit: Proptypes.func,
    cancel_button: Proptypes.func,
};


let AzureDnsProviderFormWithRouter = withRouter(AzureDnsProviderFormTemplate);

let AzureDnsProviderForm = connect(state => {

    return {
        dns_provider_configs: state.dns_provider.dns_provider_configs,
    }
},

    dispatch =>
    ({

    }))(AzureDnsProviderFormWithRouter);

export default reduxForm({
    form: "DnsProviderForm",
})(AzureDnsProviderForm);
